module.exports = __webpack_public_path__ + "static/media/redis.504ea50b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/backend/redis.png
// module id = 1522
// module chunks = 0